/**
 * CUSTOMER-R4.5 — production BANK_IBAN_ONLY stub.
 * Method-change UI must not ship NovaPay / COD / Visa copy into Customer dist.
 */
import type { StoreV2Lang } from "./store-v2-locale.js";
import type { PaymentMethodChoice } from "./checkout-validation-v2.js";
import type { ResolvePaymentMethodsInput } from "./payment-method-eligibility-v2.js";

export type PaymentMethodChoiceId = PaymentMethodChoice;

export function PaymentMethodChangeSheetV2(_props: {
  lang: StoreV2Lang;
  open: boolean;
  currentMethod: PaymentMethodChoiceId | null;
  paymentStatus?: string | null;
  eligibilityInput?: ResolvePaymentMethodsInput | null;
  loadError?: boolean;
  busy?: boolean;
  saveError?: string | null;
  onRetryLoad?: () => void;
  onClose: () => void;
  onSave: (next: PaymentMethodChoiceId) => void | Promise<void>;
  onContactManager?: () => void;
}): null {
  return null;
}
